var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutModalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 6.99982H51C52.5913 6.99982 54.1174 7.63196 55.2426 8.75718C56.3679 9.88239 57 11.4085 57 12.9998V15.9998M42 54.9998H51C52.5913 54.9998 54.1174 54.3677 55.2426 53.2425C56.3679 52.1172 57 50.5911 57 48.9998V45.9998M21.003 30.9998H21M42 30.9998H57M57 30.9998L51 24.9998M57 30.9998L51 36.9998M7.275 53.2838L25.275 58.6838C26.171 58.9528 27.1176 59.0085 28.039 58.8465C28.9604 58.6845 29.8312 58.3093 30.5817 57.7508C31.3323 57.1923 31.9419 56.466 32.3617 55.63C32.7816 54.794 33.0002 53.8714 33 52.9358V9.06382C33.0002 8.12827 32.7816 7.20564 32.3617 6.36961C31.9419 5.53359 31.3323 4.80733 30.5817 4.24885C29.8312 3.69037 28.9604 3.31515 28.039 3.15314C27.1176 2.99114 26.171 3.04685 25.275 3.31582L7.275 8.71582C6.03906 9.08681 4.95566 9.84639 4.18557 10.8818C3.41547 11.9173 2.99972 13.1734 3 14.4638V47.5358C2.99972 48.8262 3.41547 50.0824 4.18557 51.1178C4.95566 52.1532 6.03906 52.9128 7.275 53.2838Z",
    stroke: "#2EB375",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutModalIcon);
export default __webpack_public_path__ + "static/media/logout_modal-icon.7c53ad65.svg";
export { ForwardRef as ReactComponent };